var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button-group',{attrs:{"options":_vm.periodOptions},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }